import { WorkOrder } from '@atom/types/work';

import SectionHeading from '../shared/SectionHeading';
import WorkRow from '../shared/WorkRow';

import sidebarClasses from '../shared/sidebars.module.css';

export type UserWorkTabProps = {
  workOrders: WorkOrder[];
};

const UserWorkTab = ({ workOrders }: UserWorkTabProps) => {
  return (
    <div className={sidebarClasses.workPanel}>
      <SectionHeading title={`${workOrders.length} active work`} />
      <div className={sidebarClasses.workList}>
        {workOrders.map(workOrder => (
          <WorkRow key={workOrder.id} work={workOrder} />
        ))}
      </div>
    </div>
  );
};

export default UserWorkTab;
